import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import Header from 'components/Header';

import Paths from 'paths';

class AdminHome extends Component{
    render(){
        return (
            <section id="la-soundbox-container" className="home">
                <Header />
                <div className={'soundbox-grid-bar-container'}>
                    <NavLink className={'soundbox-grid-bar'} to={Paths.PATH_ADMIN_SHOW_BUNDLES} >
                        <div className={'soundbox-grid-bar-title'}>
                            <span>Liste des bundles</span>
                        </div>
                    </NavLink>
                    <NavLink className={'soundbox-grid-bar'} to={Paths.PATH_ADMIN_SHOW_SOUNDBOXS} >
                        <div className={'soundbox-grid-bar-title'}>
                            <span>Liste des soundbox</span>
                        </div>  
                    </NavLink>
                </div>
            </section>
        )
    }
}

export default AdminHome
